import { ModalBody } from 'components/modal/styled'
import styled from 'styled-components'
import { mq } from 'styles/mq'

export const Figure = styled.figure`
  break-inside: avoid-column;

  img[data-graphics] {
    aspect-ratio: unset;
  }
`

export const Image = styled.img`
  display: block;
  max-width: 100%;
  flex-grow: 1;
  height: 0;
  object-fit: contain;
`

export const ImageContainer = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  background-color: var(--text-color);

  ${mq.medium} {
    backdrop-filter: blur(5px);
    background-color: #ffffff88;
    padding: 2vmin;
  }
`

export const Caption = styled.div`
  padding: 1em;
  max-width: 25em;
  margin: 0 auto;
  background-color: var(--text-color);

  ${mq.medium} {
    margin-top: -1.2em;
  }
`
